import { PostalAddress } from '../../../common/model/postal-address';
import { LeaseAgreementCategory } from '../const/enums';

export class RentInvoicingOrderSettings {
  companyIds: string[] = [];
  leaseAgreementIds: string[] = [];
  rentPeriodIds: string[] = [];
  propertyIds: string[] = [];
  buildingIds: string[] = [];
  leaseAgreementCategory: LeaseAgreementCategory;
  invoiceRowMessages: string[] = [];
  recipientAddress: PostalAddress;
}
